var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", { ref: "cardManagement" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 text-bold bold mb-3" }, [
        _c("i", { staticClass: "fa fa-file-search color-orange" }),
        _vm._v(" Gestiones realizadas ")
      ]),
      _c(
        "div",
        { staticClass: "col-md-12 mt-2" },
        [
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-drop-down", {
                      attrs: {
                        clearable: false,
                        "custom-error-msg":
                          "Favor seleccionar Tipo de Gestión.",
                        error: errors[0],
                        fieldkey: "id",
                        fieldname: "name",
                        label: "Tipo de gestión:",
                        options: _vm.managementTypes,
                        placeholder: "Seleccione"
                      },
                      model: {
                        value: _vm.model.managementTypeId,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "managementTypeId", $$v)
                        },
                        expression: "model.managementTypeId"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-12 mt-2" },
        [
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-text-area", {
                      attrs: {
                        clearable: false,
                        "custom-error-msg": "Favor escribir un comentario.",
                        error: errors[0],
                        label: "Comentario:",
                        maxlength: 500,
                        rows: 4,
                        "show-char-count": ""
                      },
                      model: {
                        value: _vm.model.comment,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "comment", $$v)
                        },
                        expression: "model.comment"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-12 text-right mt-3 pt-1" },
        [
          _c("action-button", {
            attrs: {
              i: "fas fa-times-circle",
              text: "Cancelar",
              variant: "outline-danger mr-3"
            },
            on: {
              click: function($event) {
                return _vm.$emit("on-cancel")
              }
            }
          }),
          _c("action-button", {
            attrs: { i: "fas fa-save", text: "Guardar", variant: "success" },
            on: { click: _vm.submit }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-12 compact-calendar-container" },
        [
          _c("card-management-result", {
            ref: "cardManagementResult",
            attrs: { id: _vm.id }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }